"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumCurrencyPnlWithFactor = exports.getPositionsUuidMap = exports.sumMoveRows = exports.minMarketShiftRow = exports.getMarketShiftOutlook = exports.groupBy = exports.groupPositionsByCurrencyAndExpiry = exports.minWithIndex = exports.expandMovesWithVolatility = exports.getEmptyMovesRow = exports.reduceExtendedTableSize = exports.sumCurrencyMap = exports.positionsGreeksMap = exports.multiplyMovesByFactor = void 0;
const calculationsChart_1 = require("../calculationsChart");
const optionPricer_1 = require("../optionPricer");
const pnlCalculations_1 = require("../pnlCalculations");
const types_1 = require("../types");
const pmParams_1 = require("./pmParams");
const multiplyMovesByFactor = (row, factor) => {
    return row.map((x) => x.map((y) => y * factor));
};
exports.multiplyMovesByFactor = multiplyMovesByFactor;
const positionsGreeksMap = (positions, tickers, calculationTimestamp) => {
    let res = {};
    for (const position of positions) {
        const delta = (0, optionPricer_1.getPositionDelta)(position, tickers[position.instrument], calculationTimestamp);
        const vega = (0, optionPricer_1.getPositionVega)(position, tickers[position.instrument], calculationTimestamp);
        res[position.uuid] = { delta, vega };
    }
    return res;
};
exports.positionsGreeksMap = positionsGreeksMap;
const sumCurrencyMap = (map) => {
    const length = map[Object.keys(map)[0]].length;
    return Object.keys(map).reduce((memo, current) => {
        return (0, calculationsChart_1.sumTwoArrays)(memo, map[current]);
    }, new Array(length).fill(0));
};
exports.sumCurrencyMap = sumCurrencyMap;
const reduceExtendedTableSize = (map) => {
    let res = {};
    for (const currency of Object.keys(map)) {
        res[currency] = map[currency].map((x) => x[1]);
    }
    return res;
};
exports.reduceExtendedTableSize = reduceExtendedTableSize;
const getEmptyMovesRow = (numberOfMoves) => new Array(numberOfMoves).fill(0).map((_) => [0, 0, 0]);
exports.getEmptyMovesRow = getEmptyMovesRow;
const expandMovesWithVolatility = (moves, volDown, volUp) => {
    return moves.map((x) => [x[0] + volDown, x[1], x[2] + volUp]);
};
exports.expandMovesWithVolatility = expandMovesWithVolatility;
const minWithIndex = (arr) => {
    let min = Number.MAX_SAFE_INTEGER;
    let index = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] < min) {
            min = arr[i];
            index = i;
        }
    }
    return { min, index };
};
exports.minWithIndex = minWithIndex;
const groupPositionsByCurrencyAndExpiry = (positions) => {
    const groupPositionsByCurrency = groupBy(positions, (p) => (0, pnlCalculations_1.getBaseCurrencyFromInstrumentString)(p.instrument));
    return Object.keys(groupPositionsByCurrency).reduce((memo, currentCurrency) => {
        const postitionsByExpiry = groupBy(groupPositionsByCurrency[currentCurrency], (p) => p.instrument.split("-")[1]);
        return Object.assign(Object.assign({}, memo), { [currentCurrency]: postitionsByExpiry });
    }, {});
};
exports.groupPositionsByCurrencyAndExpiry = groupPositionsByCurrencyAndExpiry;
function groupBy(arr, keyCallback) {
    return arr.reduce((memo, current) => {
        const key = keyCallback(current);
        if (memo[key]) {
            memo[key].push(current);
        }
        else {
            memo[key] = [current];
        }
        return memo;
    }, {});
}
exports.groupBy = groupBy;
const getMarketShiftOutlook = (moves, totalMarketShiftRow) => {
    const totalRowMin = (0, exports.minMarketShiftRow)(totalMarketShiftRow);
    let marketShiftOutlook = types_1.MarketShiftOutlook.SAME;
    if (moves[totalRowMin.worstColumn.moveIndex] < 0) {
        marketShiftOutlook = types_1.MarketShiftOutlook.DOWN;
    }
    else if (moves[totalRowMin.worstColumn.moveIndex] > 0) {
        marketShiftOutlook = types_1.MarketShiftOutlook.UP;
    }
    return Object.assign(Object.assign({}, totalRowMin), { marketShiftOutlook });
};
exports.getMarketShiftOutlook = getMarketShiftOutlook;
const minMarketShiftRow = (moves) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = Number.MIN_SAFE_INTEGER;
    const worstColumn = {
        moveIndex: 0,
        volChangeIndex: 0,
    };
    for (let i = 0; i < moves.length; i++) {
        if (moves[i][0] < min) {
            min = moves[i][0];
            worstColumn.moveIndex = i;
            worstColumn.volChangeIndex = 0;
        }
        if (moves[i][1] < min) {
            min = moves[i][1];
            worstColumn.moveIndex = i;
            worstColumn.volChangeIndex = 1;
        }
        if (moves[i][2] < min) {
            min = moves[i][2];
            worstColumn.moveIndex = i;
            worstColumn.volChangeIndex = 2;
        }
        max = Math.max(max, moves[i][0], moves[i][1], moves[i][2]);
    }
    return { min, max, worstColumn };
};
exports.minMarketShiftRow = minMarketShiftRow;
const sumMoveRows = (row1, row2) => {
    const res = (0, exports.getEmptyMovesRow)(row1.length);
    for (let i = 0; i < res.length; i++) {
        res[i][0] = row1[i][0] + row2[i][0];
        res[i][1] = row1[i][1] + row2[i][1];
        res[i][2] = row1[i][2] + row2[i][2];
    }
    return res;
};
exports.sumMoveRows = sumMoveRows;
const getPositionsUuidMap = (positions) => positions.reduce((memo, current) => {
    return Object.assign(Object.assign({}, memo), { [current.uuid]: current.instrument });
}, {});
exports.getPositionsUuidMap = getPositionsUuidMap;
// Almost duplicate with the one in extended table shock.
const sumCurrencyPnlWithFactor = (currencyPnl, pmParams) => {
    const length = currencyPnl[Object.keys(currencyPnl)[0]].length;
    return (0, exports.getEmptyMovesRow)(length).map((_, i) => {
        return Object.keys(currencyPnl).reduce((memo, currentCurrency) => {
            const marginMultiplier = pmParams.currencyParams[currentCurrency].group ===
                pmParams_1.ProductGroup.LargeCap
                ? pmParams.general.largeCap
                : pmParams.general.midCap;
            const volDown = currencyPnl[currentCurrency][i][0] < 0
                ? currencyPnl[currentCurrency][i][0]
                : currencyPnl[currentCurrency][i][0] * marginMultiplier;
            const volSame = currencyPnl[currentCurrency][i][1] < 0
                ? currencyPnl[currentCurrency][i][1]
                : currencyPnl[currentCurrency][i][1] * marginMultiplier;
            const volUp = currencyPnl[currentCurrency][i][2] < 0
                ? currencyPnl[currentCurrency][i][2]
                : currencyPnl[currentCurrency][i][2] * marginMultiplier;
            return [memo[0] + volDown, memo[1] + volSame, memo[2] + volUp];
        }, [0, 0, 0]);
    });
};
exports.sumCurrencyPnlWithFactor = sumCurrencyPnlWithFactor;
